import React, { useEffect, useRef, useState } from "react";
import { db, firebaseAuth } from "../db/firestore";
import { useParams } from "react-router-dom";
import { Modal_Loading, Modal_Success } from "../modal";
import { colors, initialProduct } from "../configs";
import { findInArray, formatTime } from "../Utility/function";
import { Table } from "react-bootstrap";
import { NumberYMD } from "../Utility/dateTime";
import ExcelJS from "exceljs";
import { v4 as uuidv4 } from 'uuid';
import { OneButton } from "../components";
import * as XLSX from 'xlsx';
import firebase from 'firebase/app';

const { white } = colors;

// ไว้อัปเฟรนไชส์
function ManualUploadScreen() { // manual upload สำหรับอัปโหลดเองหลังบ้าน
    const [shop, setShop] = useState({ shopId:'', name:'', warehouseCategory:[], vip:[], id:'' })
    const { shopId, name, warehouseCategory, vip, id } = shop;
    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success_Modal, setSuccess_Modal] = useState(false);

    const [products, setProducts] = useState([]);


    useEffect(()=>{
        handleFetch()
    },[]);

    async function handleFetch(){
        setLoading(true)
        try {
            const shopDoc = await db.collection('franchise').doc('otuuBh9S194gZFY5o1wL').get();
            // const shopDoc = await db.collection('shop').doc('OK6QGE73oAalbSKJv79t').get();
            setShop({...shopDoc.data(), id:shopDoc.id })
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];

        if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const arrayBuffer = e.target.result;
            const workbook = new ExcelJS.Workbook();

            await workbook.xlsx.load(arrayBuffer);
            const worksheet = workbook.getWorksheet(1);

            const extractedProducts = [];
            worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) { // Skip header
                extractedProducts.push({
                    barcode: (row.getCell(1).value||''), // Assuming name in column A
                    name: row.getCell(2).value||'', // Assuming name in column A
                    price: row.getCell(3).value||'', // Assuming name in column A
                    cost: row.getCell(4).value||'', // Assuming name in column A
                    unit: row.getCell(5).value||'', // Assuming name in column A
                    category: row.getCell(6).value||'', // Assuming name in column A
                    stock: row.getCell(7).value||'', // Assuming name in column A
                    barcodeStatus: row.getCell(8).value == '1', // Assuming name in column A
                });
            }
            });
            setProducts([...extractedProducts].map(a=>({...a,barcode:String(a.barcode).replace(/^'/, ''),name:String(a.name)}))); // Now update the state
                let catSet = new Set();
                let cat = [];

                for (const item of extractedProducts) {
                    if (!catSet.has(item.category) && item.category) {
                        catSet.add(item.category);
                        cat.push({ id: uuidv4(), category: item.category });
                    }
                }
            const firstLevelMap = new Map(
                (warehouseCategory.find(a => a.level === 1)?.value || []).map(b => [b.name, b.id])
                );
                
            cat = cat.map(a => {
            const id = firstLevelMap.get(a.category);
            return id ? { ...a, id } : a;
            });
            setCategory(cat)

        };

        reader.readAsArrayBuffer(file);
        }
    };

    async function addProductsToDatabase() {
        if (products.length === 0) {
            return alert('กรุณาอัปโหลดไฟล์ในข้อ 2.');
        };
    
        try {
            setLoading(true);
    
            const BATCH_LIMIT = 500;
            const productChunks = [];
    
            // Split products into chunks of 500
            for (let i = 0; i < products.length; i += BATCH_LIMIT) {
                productChunks.push(products.slice(i, i + BATCH_LIMIT));
            }
    
            // Process each chunk sequentially
            for (const chunk of productChunks) {
                const batch = db.batch();
    
                chunk.forEach(({ name, price, cost, category: thisCategory, stock, unit, barcode, barcodeStatus }) => {
                    const newItem = {
                        ...initialProduct,
                        name,
                        franchiseId:'otuuBh9S194gZFY5o1wL',
                        price: Number(price),
                        cost: Number(cost),
                        stock: Number(stock),
                        category: [],
                        unit,
                        barcode: String(barcode),
                        updateTime:firebase.firestore.FieldValue.serverTimestamp(),
                        barcodeStatus
                    };
    
                    if (thisCategory) {
                        const categoryId = findInArray(category, 'category', thisCategory)?.id;
                        newItem.category = [categoryId];
                    }
    
                    const newDocRef = db.collection('warehouseItem').doc();
                    batch.set(newDocRef, newItem);
                });
    
                await batch.commit(); // commit each batch
            }
    
            // Process categories once, not in the batch (it's not part of the 500 limit)
            if (category.length > 0) {
                const newCategories = category.map(({ id, category }) => ({
                    aboveId: [],
                    level: 1,
                    id,
                    name: category,
                }));
    
                let updatedShopCategory = [...warehouseCategory];
                const firstLevelCategory = updatedShopCategory.find(a => a.level === 1);
    
                if (firstLevelCategory) {
                    const categoryIds = new Set(firstLevelCategory.value.map(a=>a.id))
                    firstLevelCategory.value = [...firstLevelCategory.value, ...newCategories.filter(a=>!categoryIds.has(a.id))];
                } else {
                    updatedShopCategory.push({ level: 1, value: newCategories });
                }
    
                await db.collection('franchise').doc('otuuBh9S194gZFY5o1wL').update({ warehouseCategory: updatedShopCategory });
            }
    
            console.log('All batch writes successful');
    
            setProducts([]);
            setShop({ shopId: '', name: '', warehouseCategory: [] });
            setSuccess_Modal(true);
            setTimeout(() => setSuccess_Modal(false), 900);
        } catch (error) {
            console.error('Error adding products:', error);
        } finally {
            setLoading(false);
        }
    }
    const fileInputRef = useRef(null);
    const triggerFileUpload = () => {
        // Trigger the hidden file input when the button is clicked
        fileInputRef.current.click();
    };

    const exportToExcel = () => {
        // Create a worksheet from your table data
        const worksheetData = [];
    
        // Create headers
        const headers = ['บาร์โค้ด','ชื่อสินค้า','ราคาขาย','ต้นทุนต่อหน่วย','หน่วย','หมวดหมู่','จำนวนคงเหลือ'];
        worksheetData.push(headers);
    
    
        // Create a new workbook and add the worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
    
        // Use sanitized sheet name
        const sheetName = 'แม่แบบสำหรับอัปโหลดสินค้า'
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    
        // Export the workbook to a file
        XLSX.writeFile(workbook, `แม่แบบสำหรับอัปโหลดสินค้าช็อปแชมป์.xlsx`);
      };

  return (
    <div style={{  height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor:white, width:'100vw' }}>
        <Modal_Loading show={loading} />
        <Modal_Success show={success_Modal} />
        <h1>อัปโหลดสินค้าผ่านไฟล์</h1>
        <h4>ร้าน {name}</h4>
        <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            ref={fileInputRef}
            style={{ display: "none" }} // Hide the input field
        />
        <div style={{ display:'flex', margin:10 }} >
            <OneButton {...{ text:'1.ดาวน์โหลดไฟล์แม่แบบ', submit:exportToExcel, variant:'dark' }} />&emsp;
            <OneButton {...{ text:'2.อัปโหลดไฟล์', submit:triggerFileUpload, variant:'warning' }} />&emsp;
            <OneButton {...{ text:'3.บันทึกสินค้าเข้าคลัง', submit:addProductsToDatabase, variant:'success' }} />

        </div>
        <h5>ทั้งหมด {products.length} รายการ</h5>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={styles.text2}>No.</th>
                    <th style={styles.text}>บาร์โค้ด</th>
                    <th style={styles.text}>ชื่อสินค้า</th>
                    <th style={styles.text}>ราคาขาย</th>
                    <th style={styles.text}>ต้นทุนต่อหน่วย</th>
                    <th style={styles.text}>หน่วย</th>
                    <th style={styles.text}>หมวดหมู่</th>
                    <th style={styles.text}>จำนวนคงเหลือ</th>
                    <th style={styles.text}>barcodeStatus</th>
                </tr>
            </thead>
        <tbody  >
            {products.map((item, index) => {
                const { barcode, name, price, cost, unit, category, stock, barcodeStatus } = item;
                return <tr  key={index} >
                            <td style={styles.text3}>{index+1}.</td>
                            <td style={styles.text3} >{barcode}</td>
                            <td style={styles.text3} >{name}</td>
                            <td style={styles.text3}>{price}</td>
                            <td style={styles.text3}>{cost}</td>
                            <td style={styles.text3}>{unit}</td>
                            <td style={styles.text3}>{category}</td>
                            <td style={styles.text3}>{stock}</td>
                            <td style={styles.text3}>{barcodeStatus?'true':'false'}</td>
                        </tr>
            })}
        </tbody>
        </Table>
        <br/>
   
    </div>
  );
};

const styles = {
    text : {
        width:'15%', minWidth:'150px', textAlign:'center'
    },
    text2 : {
        width:'10%', minWidth:'50px'
    },
    text3 : {
        textAlign:'center'
    }
}

export default ManualUploadScreen;